import store from '../store/index'
// 规则组名
export const RULE_GROUP = {
  STATION_RANGE:'STATION_RANGE', // 站点
  SKU_RANGE:'SKU_RANGE', // 货品
  ORDER_CREATE_TIME_CHECK:'ORDER_CREATE_TIME_CHECK', // 下单时间
  CUSTOM_FIELDS:'CUSTOM_FIELDS', // 自定义字段
  SENSITIVE_FIELDS: 'SENSITIVE_FIELDS', // 数据敏感字段
  BEFORE_PRICING: 'BEFORE_PRICING', // 预计费
  PARENT_ORDER_MARK:'PARENT_ORDER_MARK', // 子母单
}

// 规则类型
export const RULE_TYPE = {
  orderRules: 'orderRules', // 下单规则
  sensitiveFields: 'sensitiveFields', // 敏感字段
}

// store 参数名
export const PARAMS_NAME = {
  orderRules: 'SET_ORDER_RULES', // 下单规则
  sensitiveFields: 'SET_SENSITIVE_FIELDS', // 敏感字段
}

// 下单页面自定义字段
export const ORDER_CUSTOME_FIELDS = {
  needPickUp: '是否提货', // 是否提货
  needDelivery: '是否配送',  // 是否配送
  mileageKm: '预估里程', // 预估里程
  crmNumber: '外部单号', // 外部单号
}
// 货品查询参数
export const SKU_RULE_PARAMS = (prop) => {
  const {customerCode,tenantId } = store.state.user;
  const {customerCodes } = store.state.orderRules;
  const params = {
    CUSTOMER_TENANT: {
      ownerTenantId: tenantId,
      customerCode,
    },
    CUSTOMER_CODE: {
      customerCode,
    },
    CUSTOMER_CREDIT_CODE: {
      customerCodes,
    }
  }
  return params[prop]
}

// 站点查询参数
export const STATION_RULE_PARAMS =(prop)=> {
  const { customerCode, tenantId } = store.state.user;
  const {customerCodes } = store.state.orderRules;
  const params = {
    CUSTOMER_TENANT: {
      tenantIds: [tenantId],
      customerCodes: [customerCode],
    },
    CUSTOMER_CODE: {
      customerCodes: [customerCode],
    },
    CUSTOMER_CREDIT_CODE: {
      customerCodes,
    }
  }
  return params[prop]
}

// 下单时间范围单位
export const TIME_UNIT = {
  HOURS: 'HOURS',
  DAYS: 'DAYS',
}

// 下单时间范围单位
export const TIME_UNIT_MAP = {
  HOURS: 'hours',
  DAYS: 'days',
}

// 处理时间
export const range = (start, end) =>{
  const result = [];
  for (let i = start; i < end; i+=1) {
    result.push(i);
  }
  return result;
}

// 订单轨迹相关字段
export const MAP_FIELDS = {
  temperature: 'temperature',
  track: 'track',
}

export const ConfigEnum = {
  WAREHOUSE_ORDER_DEMO_VERSION_LIST:'WAREHOUSE_ORDER_DEMO_VERSION_LIST', // 货主端仓下单演示版本名单
}